const Menu = [
  { is_header: true, title: "Overview" },
  { path: "/dashboard", icon: "bi bi-cpu", title: "Overview" },
  { path: "/matar-dashboard", icon: "bi bi-cpu", title: "Overview" },
  {
    path: "/machine-health",
    icon: "bi bi-bar-chart",
    title: "Machine Health",
    children: [
      { path: "/machine-health", title: "Machine Health" },
      { path: "/machine-comparison", title: "Machine Comparison" },
    ],
  },
  // {
  //   path: "/analytics",
  //   icon: "bi bi-pie-chart",
  //   title: "Weekly Analytics",
  // },
  {
    path: "/alarm/list",
    icon: "bi bi-exclamation-octagon",
    title: "Alarm",
  },
  {
    path: "/notification-logs",
    icon: "bi bi-bell",
    title: "Notification Logs",
  },
  {
    path: "/machine/list",
    icon: "bi bi-boombox",
    title: "Machines",
    children: [
      { path: "/machine/hierarchy", title: "Machine Hierarchy" },
      { path: "/machine/list", title: "Machine List" },
    ],
  },
  {
    path: "/machine-asset/asset-list",
    icon: "bi bi-boombox",
    title: "Monitored Assets",
    children: [
      { path: "/machine/hierarchy", title: "Machine Hierarchy" },
      { path: "/machine-asset/asset-list", title: "Machine List" },
    ],
  },
  {
    path: "/machine-asset/investment-list",
    icon: "bi bi-list-check",
    title: "Investment Profile",
  },
  {
    path: "/machine-asset/financial-strategies",
    icon: "fa fa-money-bill",
    title: "Financial Strategies",
  },
  {
    path: "/report/export",
    icon: "bi bi-file-pdf",
    title: "Reports",
    children: [
      { path: "/report/export", title: "Report Generator" },
      { path: "/report/document", title: "Documents" },
    ],
  },

  {
    path: "/configuration",
    icon: "bi bi-gear",
    title: "Configuration",
    children: [
      { path: "/configuration/company", title: "Company Profile" },
      { path: "/configuration/location", title: "Location" },
      { path: "/configuration/roles", title: "Roles" },
      { path: "/configuration/group", title: "Asset Group" },
      { path: "/configuration/users", title: "Users" },
      {
        path: "/configuration/notification-hierarchy",
        title: "Notification Hierarchy",
      },
    ],
  },
];

export default Menu;
